import * as Yup from 'yup'

export const initialValues = email => ({
    email: email || '',
})

export const validationSchema = Yup.object().shape({
    email: Yup.string()
        .email('Email is invalid')
        .required('Email is required'),
})
